import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import React from "react";
import { AppContext, User } from "../../../../context/appContext";
import { AdminListContext } from "../context/adminListContext";
import AdminProps from "../interface/adminProps";

const OptionMenu = ({ admin }: { admin: AdminProps }): React.JSX.Element => {
  const {
    setRevokeAdmin,
  }: {
    setRevokeAdmin: React.Dispatch<React.SetStateAction<AdminProps | null>>;
  } = React.useContext(AdminListContext);

  const { user }: { user: User } = React.useContext(AppContext);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  // admins must not lock themselves out, so the action is unavailable on the own entry
  const isOwnEntry = Number(user.id) === admin.userId;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void =>
    setAnchorEl(event.currentTarget);

  const handleClose = (): void => setAnchorEl(null);

  return (
    <React.Fragment>
      <IconButton
        sx={{ mr: 1 }}
        id={`admin-option-button-${admin.userId}`}
        aria-controls={open ? `admin-option-menu-${admin.userId}` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        aria-label={`Optionen für ${admin.firstName} ${admin.lastName}`}
        onClick={handleClick}
      >
        <MoreHorizOutlinedIcon
          sx={{
            transform: "rotate(90deg)",
          }}
        />
      </IconButton>

      <Menu
        id={`admin-option-menu-${admin.userId}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `admin-option-button-${admin.userId}`,
        }}
      >
        <MenuItem
          disabled={isOwnEntry}
          onClick={() => {
            setRevokeAdmin(admin);
            handleClose();
          }}
        >
          Admin-Rechte entziehen
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default OptionMenu;
